export enum DrawerLayout {
  Horizontal,
  Vertical,
}

export enum DrawerMode {
  Push,
  Overlay,
}
